<div>
  <div class="selector-div-wrapper">
    <span>Mostrar</span>
    <div class="form-check form-switch">
      <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="minimap-switch"
        (change)="onSelect($event)" [(ngModel)]="tool.enabled" [checked]="tool.enabled" />
    </div>
  </div>
  <div class="position-wrapper">
    <span>Posición</span>
    <div class="positions-container">
      <button id="top-right-btn" [ngClass]="{ active: tool?.position.top }" class="position-btn"
        (click)="onValueChange('top')">
        <img class="top-right" src="/assets/img/tools/minimap/topright.svg" alt="" />
        Top
      </button>
      <button id="bottom-left-btn" [ngClass]="{ active: tool?.position.bottom, disabled: disablePositions.bottom }"
        class="position-btn" (click)="onValueChange('bottom')">
        <img class="bottom-left" src="/assets/img/tools/minimap/bottomleft.svg" alt="" />
        Bottom
      </button>
    </div>
  </div>
  <!-- <div class ="alert-iframe-text" *ngIf="multivenueTool.values.enabled">
        <span>Barra bloquedada por el modo multivenue</span>
    </div> -->
  <div class="save-data-container">
    <p>ID de Minimapa:</p>
    <input class="input-wrapper" type="text" name="map_id" placeholder="minimap ID" [(ngModel)]="tool.map_id" />
  </div>
</div>